export function encodePassword(password) {
  return btoa(password);
}
